/* tool/details/table.js */
var Marionette = require('backbone.marionette');
var $ = require('jquery');
var d3 = require('d3');
var template = require('./template.hbs');

module.exports = Marionette.ItemView.extend({
	template: template,
  tagName: 'div',

	initialize: function(){
		var scope = this;
		this.listenTo(UCS.App.MapState,'change:selection', this.update);
	},

	onAttach: function(){
		this.update();
	},

	update: function(){
		var d = UCS.App.MapState.get('selection');

		// Tweening numbers?
		// http://stackoverflow.com/questions/13454993/changing-number-displayed-as-svg-text-gradually-with-d3-transition
		// http://jsfiddle.net/c5YVX/8/
    // d3.select('.details-layout .table .revenue')
		// 	.data(d)
	  //   .enter()
		// 	.transition()
		// 	.duration(3000)
		// 	.tween("text", function(d) {
		// 		var i = d3.interpolate(this.textContent, d.total_revenue);
		//
		// 		return function(t) {
		// 				this.textContent = Math.round(i(t));
		// 		};
		// 	});

		var overviewData = UCS.App.MapState.get('overview_data');


		if(UCS.App.MapState.get('zoomed') === false ){
			$('.details-layout .table .revenue').html( overviewData.total_revenue );
	    $('.details-layout .table .employees').html( overviewData.employees );
	    $('.details-layout .table .startups').html( overviewData.startups );
			$('.details-layout .table .sbir').html( overviewData.sbir );
	    $('.details-layout .table .venture').html( overviewData.venture );

			return;
		}
    $('.details-layout .table .revenue').html(d.total_revenue);
    $('.details-layout .table .employees').html(d.num_employees);
    $('.details-layout .table .startups').html(d.num_startups);
		$('.details-layout .table .sbir').html( d.sbir );
		$('.details-layout .table .venture').html( d.venture );
	}

});
